import React, { createContext, useContext } from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import { getStorage } from "../auth/utils";

const GoogleMapsContext = createContext({ isLoaded: false });

const LIBRARIES = ["places", "marker"];

export const GoogleMapsProvider = ({ children }) => {
  const getLanguage = () => {
    const storedLang = getStorage().getItem("language") || "el";
    return storedLang === "gr" ? "el" : storedLang;
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    version: "weekly",
    language: getLanguage(),
    libraries: LIBRARIES,
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => useContext(GoogleMapsContext);
